import { type FC } from "react";
import { Badge } from "@aws-amplify/ui-react";

// Rating levels configuration
const ratingLevels = [
  {
    number: 0,
    textColour: "white",
    backgroundColour: "#db2828",
    name: "No capability",
  },
  {
    number: 1,
    textColour: "white",
    backgroundColour: "#f2711c",
    name: "Basic proficiency",
  },
  {
    number: 2,
    textColour: "white",
    backgroundColour: "#fbbd08",
    name: "Some experience",
  },
  {
    number: 3,
    textColour: "white",
    backgroundColour: "#767676",
    name: "Average expertise",
  },
  {
    number: 4,
    textColour: "white",
    backgroundColour: "#b5cc18",
    name: "Advanced",
  },
  {
    number: 5,
    textColour: "white",
    backgroundColour: "#21ba45",
    name: "Expert",
  },
];

interface SkillRatingBadgeProps {
  rating?: number | null;
  size?: "small" | "large";
}

const SkillRatingBadge: FC<SkillRatingBadgeProps> = ({
  rating,
  size = "small",
}) => {
  // Show "Not rated" for null, undefined, or 0 ratings
  if (rating === null || rating === undefined || rating === 0) {
    return (
      <Badge backgroundColor="#f0f0f0" color="#666" size={size}>
        Not rated
      </Badge>
    );
  }

  // Ensure rating is within valid range
  const validRating = Math.min(Math.max(1, rating), 5);
  const level = ratingLevels[validRating];

  return (
    <Badge
      backgroundColor={level.backgroundColour}
      color={level.textColour}
      size={size}
    >
      {level.name} ({validRating})
    </Badge>
  );
};

export default SkillRatingBadge;
